export const CSVToMatrix = (csv, delimiter) => {
  let matrix = [];
  csv.split('\n').map(l => { l.trim() == "" ? 0 : matrix.push(l.trim().split(delimiter).map(v => v.trim())) });
  return matrix;
}

export const MatrixToJSON = (matrix, from, to) => {
  let jsonResult = []; from = from||0;
  matrix.map((a, i) => {
    let obj = Object.assign({}, ...matrix[0].map((h, index) => ({[h]: matrix[i][index]})));
    jsonResult.push(obj);
  });
  return to ? jsonResult.splice(from, to): jsonResult.splice(from);
}


// WEBPACK FOOTER //
// ./src/components/common/csvUtils.js